import React from 'react';
import './InstructionModal.css';

export default function InstructionModal({ onClose }) {
  return (
    <div className="modal-overlay">
      <div className="modal-card">
        <h2>📘 How It Works</h2>
        <p>This timer is based on the Pomodoro Technique:</p>
        <ol>
          <li>⏱ Work for 25 minutes (1 session)</li>
          <li>☕ Take a 5-minute short break</li>
          <li>🔁 After 4 sessions, take a long break (15–30 minutes)</li>
        </ol>
        <p>
          🎯 Add tasks with estimated sessions. Each session is one 25-minute block of focused work.
        </p>

        <hr style={{ margin: '20px 0', opacity: 0.3 }} />

        <h3>About This App</h3>
        <p>
          I built <strong>ProdPilot</strong> to help creators and freelancers like myself manage
          time better. I personally use this every day to stay focused and avoid burnout while
          working on things I love.
        </p>
        <p>
          This isn’t just another productivity tool — it’s something I made because I needed it.
          Everything here reflects real challenges I’ve faced and solved through trial and error.
        </p>
        <p>
          If this helps you too, consider <a href="https://buymeacoffee.com/prodpilot" target="_blank" rel="noopener noreferrer" className="inline-coffee-link">buying me a coffee</a> ☕ — it really helps support future updates.
        </p>

        <button onClick={onClose}>Close</button>
      </div>
    </div>
  );
}
